import React from "react";
import { Dialog, JSONViewer } from "../../../ui";

interface JsonTraceModalProps {
  data: Record<string, any> | null;
  onClose: () => void;
}

export function JsonTraceModal({ data, onClose }: JsonTraceModalProps) {
  return (
    <Dialog
      title="Raw JSON Trace"
      onClose={onClose}
      maxWidth="max-w-4xl"
      maxHeight="max-h-[85vh]"
      ariaLabelledBy="json-trace-modal-title"
    >
      <JSONViewer data={data} maxHeight="max-h-[70vh]" />
    </Dialog>
  );
}
